import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PurposeLedgerMapHeader } from '../models/purpose-leger-mapmaster-mode';


@Injectable({
  providedIn: 'root'
})
export class AccountsMastersService {

  constructor(private http: HttpClient) {}


  //_Ledgerhead_Master_API's
  lFN_GetLedgerHeadsMasterList(){
   return this.http.get(`${environment.ROOT_URL}/jsyogaccountsmasters/ledgerheadsmst`, { withCredentials: true, responseType: 'text', observe: 'response' });
  }



  //_Purpose_Ledgerhead_Mapping_Master_API's
  lFN_GetPurposeLedgerHeadsMappingList(){
    return this.http.get(`${environment.ROOT_URL}/jsyogaccountsmasters/purposeledgerheadsmst`, { withCredentials: true, responseType: 'text', observe: 'response' });
   }

  lFN_SavePurposeMappingMasterTransactions(l_purposeLedgerMapHeader: PurposeLedgerMapHeader){
    return this.http.post(`${environment.ROOT_URL}/jsyogaccountsmasters/savepurposeledgerheadsmst`, l_purposeLedgerMapHeader , { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  lFN_ApprovePurposeMappingMaster(l_purposeLedgerMapApproval: PurposeLedgerMapHeader){
    return this.http.post(`${environment.ROOT_URL}/jsyogaccountsmasters/approvepurposeledgerheadmst`, l_purposeLedgerMapApproval, { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  
}
